import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import imgPreview from './directives/imgPreview';
/*
// 页面刷新时清理临时存储数据
const clearStorageOnRefresh = () => {
  try {
    // 删除 agent-form-step4 和 user 存储项
    expiredStorage.removeItem('agent-form-step4')
    expiredStorage.removeItem('agent-form-step44')
    expiredStorage.removeItem('user')
    console.log('✅ 已清理临时存储数据: agent-form-step4, user')
  } catch (error) {
    console.warn('清理存储数据时出错:', error)
  }
}

// 在应用启动前清理存储
clearStorageOnRefresh()*/
// 开发环境下导入测试工具
if (process.env.NODE_ENV === 'development') {
    import('./utils/testExpiredStorage');
}
const app = createApp(App);
app.use(router);
app.directive('img-preview', imgPreview);
app.mount('#app');
